module.exports = __webpack_public_path__ + "img/CD.b6148989.svg";